export default __webpack_public_path__ + "static/3-da975e23b1cba6f192a4cf7c59a914bc.jpeg";